<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('rulesForm.detailCompensationTitle') }}</h2>
            <p class="text-muted small mb-0">{{ compensation.name || ($currentLocale === 'id' ? 'Tugas Kompensasi' : 'Compensation Task') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
          <router-link :to="{ name: 'EditCompensation', params: { id: id } }" class="btn btn-primary px-3 py-2 mr-2 font-weight-bold">
            <i class="mdi mdi-lead-pencil mr-1"></i> {{ $t('common.edit') }}
          </router-link>
          <button type="button" class="btn btn-outline-danger px-3 py-2" @click="confirmDelete" :disabled="loading">
            <i class="mdi mdi-delete-outline mr-1"></i> {{ $t('common.delete') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Main Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <div class="row">
            <!-- Left Column: Compensation Details -->
            <div class="col-md-7 mb-4">
              <span class="badge badge-outline-success px-3 py-2 font-weight-bold text-uppercase mb-3 d-inline-block">
                <i class="mdi mdi-shield-refresh-outline mr-1"></i> {{ $t('quests.compensationTask') }}
              </span>

              <h3 class="text-white font-weight-bold mb-3">{{ compensation.name }}</h3>

              <div class="p-3 bg-dark rounded border border-secondary mb-4">
                <label class="text-muted small text-uppercase font-weight-bold d-block mb-2">{{ $t('common.description') }}</label>
                <p class="text-white mb-0" style="white-space: pre-wrap;">{{ compensation.description || ($currentLocale === 'id' ? 'Tidak ada petunjuk khusus untuk tugas kompensasi ini.' : 'No specific instructions provided for this compensation task.') }}</p>
              </div>

              <div class="text-muted small">
                <i class="mdi mdi-clock-outline mr-1"></i> {{ $t('common.date') }}: {{ formatDate(compensation.created_at) }}
              </div>
            </div>

            <!-- Right Column: Remedial Context -->
            <div class="col-md-5 mb-4">
              <div class="p-4 bg-dark rounded border border-secondary h-100 d-flex flex-column justify-content-center">
                <div class="d-flex align-items-center mb-3">
                  <div class="avatar-circle mr-3" style="width: 44px; height: 44px; background: rgba(16, 185, 129, 0.2); color: #10b981; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 20px;">
                    <i class="mdi mdi-hand-heart"></i>
                  </div>
                  <div>
                    <h5 class="text-white font-weight-bold mb-0">{{ $currentLocale === 'id' ? 'Misi Pemulihan (Kompensasi)' : 'Remedial Task (Compensation)' }}</h5>
                    <small class="text-muted">{{ $currentLocale === 'id' ? 'Pemulihan Penalti & Reputasi Poin' : 'Penalty & Reputation Recovery' }}</small>
                  </div>
                </div>
                <p class="text-muted small mb-0">
                  {{ $currentLocale === 'id' ? 'Anggota tim yang terkena penalti dapat mengambil tugas kompensasi ini dan mengunggah bukti penyelesaian. Setelah disetujui Manajer, status pelanggaran akan dipulihkan secara transparan.' : 'Team members who receive an SOP penalty can take this compensation task and upload completion proof. Once approved by a Manager, their violation record is transparently resolved.' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailCompensation, deleteCompensation } from "../../services/compensationService";
import Swal from 'sweetalert2';
import moment from 'moment';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    compensation: {},
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    async fetchCompensation() {
      try {
        const response = await getDetailCompensation(this.id);
        this.compensation = response.data || {};
      } catch (err) {
        console.error('Error fetching compensation:', err);
      }
    },
    confirmDelete() {
      Swal.fire({
        title: this.$t('quests.confirmDelete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        cancelButtonColor: '#6b7280',
        confirmButtonText: this.$t('common.delete'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.loading = true;
            await deleteCompensation(this.id);
            Swal.fire({
              icon: 'success',
              title: this.$t('common.success'),
              text: this.$t('rulesForm.deletedSuccess'),
              confirmButtonColor: '#3b82f6'
            });
            this.$router.push('/rules/compensations');
          } catch (err) {
            Swal.fire({
              icon: 'error',
              title: this.$t('common.error') || (this.$currentLocale === 'id' ? 'Terjadi Kesalahan' : 'Error'),
              text: this.$currentLocale === 'id' ? 'Gagal menghapus tugas kompensasi.' : 'Failed to delete compensation task.',
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD MMM YYYY, HH:mm');
    }
  },
  mounted() {
    this.fetchCompensation();
  }
};
</script>
